module.exports = __webpack_public_path__ + "static/play-button-2138735_640-3b62c6ca4fbf30726f22fd05d6e6fde3.png";